/**
 * An OTP from GSTN, as typed into a box.
 * @file src/web/shared/utils/otp.ts
 *
 * The server's rule (api/features/gst/otp.ts), for the screens: GSTN's OTPs
 * are six letters or digits — an EVC OTP can carry letters — so nothing here
 * assumes digits. Spaces are dropped and letters upper-cased as it is typed.
 */

/** Spaces and anything not a letter or digit removed, upper-cased, at most six. */
export const typedOtp = (v: string): string => v.replace(/[^A-Za-z0-9]/g, '').toUpperCase().slice(0, 6);

/** Six letters or digits. */
export const isOtp = (v: string): boolean => /^[A-Z0-9]{6}$/.test(v);
